import {
  faCheckCircle,
  faCircleNotch,
  faExclamationCircle,
  faInfoCircle,
  faWarning,
} from '@fortawesome/pro-regular-svg-icons';

import PanelTypes from '../types/PanelTypes';

import COLOURS from 'css/export-vars.module.scss';

// This is a function to get props instead of a constant so we don't have to rely on the fontawesome chunk
// being available on module initialisation
export default () => ({
  [PanelTypes.SUCCESS]: {
    background: COLOURS.pastelGreen,
    highlightColorName: 'success',
    iconColorName: 'success',
    defaultIcon: faCheckCircle,
    textColorName: 'black',
  },
  [PanelTypes.WARNING]: {
    background: COLOURS.notificationPastelYellow,
    highlightColorName: 'warning',
    iconColorName: 'warning',
    defaultIcon: faWarning,
    textColorName: 'black',
  },
  [PanelTypes.DANGER]: {
    background: COLOURS.lightPastelRed,
    highlightColorName: 'danger',
    iconColorName: 'danger',
    defaultIcon: faExclamationCircle,
    textColorName: 'black',
  },
  [PanelTypes.INFO]: {
    background: COLOURS.lightGrey,
    highlightColorName: 'midGrey',
    iconColorName: 'black',
    defaultIcon: faInfoCircle,
    textColorName: 'black',
  },
  [PanelTypes.LOADING]: {
    background: COLOURS.background,
    highlightColorName: 'midGrey',
    iconColorName: 'black',
    defaultIcon: faCircleNotch,
    textColorName: 'black',
  },
});
